import { SingleComboBox } from "@itandi/itandi-bb-ui/SingleComboBox";
import type { ComponentProps } from "react";
import { useCallback, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import type { CompanyVendor } from "~/models/CompanyVendor";
import { convertToComboBoxOption } from "~/models/CompanyVendor";
import type { DealSearchCondition } from "~/models/Deal";

type Props = {
	companyVendors: CompanyVendor[];
};

export function CompanyVendorCombobox({ companyVendors }: Props) {
	const { setValue, control } = useFormContext<DealSearchCondition>();
	const watchedCompanyVendorId = useWatch({ control, name: "companyVendorId" });

	const companyVendorOption = useMemo((): ComponentProps<
		typeof SingleComboBox
	>["value"] => {
		const vendor = companyVendors.find(
			({ id }) => id === watchedCompanyVendorId
		);
		return vendor ? convertToComboBoxOption(vendor) : null;
	}, [companyVendors, watchedCompanyVendorId]);

	const onCompanyVendorChange: Required<
		ComponentProps<typeof SingleComboBox>
	>["onChange"] = useCallback(
		(value) => {
			setValue("companyVendorId", value ? Number(value.value) : undefined);
		},
		[setValue]
	);

	return (
		<SingleComboBox
			onChange={onCompanyVendorChange}
			options={companyVendors.map((c: CompanyVendor) =>
				convertToComboBoxOption(c)
			)}
			placeholder="施工会社"
			value={companyVendorOption}
		/>
	);
}
